export default __webpack_public_path__ + "static/media/voice-not-found.933317c8.svg";